import search from '../../../components/search.vue'
import branchLibraryItem from '../../branchLibraryItem'
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {store} from '../../../store/store.js'
import {CommonUtil} from "../../../common/CommonUtil";
import Page from '../../../components/page.vue'
export default {
  name:'libraryPart',
  data(){
    return {
      isLibrary:true,
      supperCentrallibrary:[],//上级中心馆
      centralLibrary:[],//上级总馆对象
      branchLibrary:[],//上级分馆对象
      branchCentralLibrary:[],//下级总馆List
      levelbranchLibrary:[],//下级分馆List
      branchLibraryOutlets:[],//下级网点List
      activeLibrary:[],//页面呈现出来的图书馆
      activeID:1,//初次渲染id
      webType:store.webType,
      opacType: store.opacType,
      pageData:{
        pageNo:1,//当前页码
        data:[],//当前页展示数据，数组
        pageSize:9,//每页最多显示条数
        length:0,//总的数据条数
        totalPage:1,//总页数
      }
    }
  },
    components:{
      search,
      branchLibraryItem,
      Page
  },
    watch:{
        $route() {
            this.queryList();
        }
    },
  beforeMount() {
    if(store.webType == 0) {
      store.libraryNav.activeNav = '总分馆';
    } else {
      store.wrap.activeRouteName = '总分馆';
    }
    this.queryList();
  },
  methods: {
    queryList:function () {
        let locationCode = this.$route.query.latLng || store.localtionArea.latLng;
        let libCode = this.$route.query.libCode || this.$route.query.hallCode;
        let url=api.library.getAllLibrary.replace('{libCode}',libCode).replace('{lngLat}',locationCode).replace('{pageNo}',1).replace('{pageCount}',3);
        ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
          this.branchCentralLibrary = data.branchLibrarys.branchCentralLibrary;
          this.levelbranchLibrary = data.branchLibrarys.branchLibrary;
          this.branchLibraryOutlets = data.branchLibrarys.branchLibraryOutlets;
          if(data.supper.supperCentrallibrary){
            this.supperCentrallibrary.push(data.supper.supperCentrallibrary)
          }
          if(data.supper.centralLibrary){
            this.centralLibrary.push(data.supper.centralLibrary)
          }
          if(data.supper.branchLibrary){
            this.branchLibrary.push(data.supper.branchLibrary);
          }
          this.initLibaranNav();
          //前端分页
          this.pageData = CommonUtil.getTableData(1,this.pageData.pageSize,this.activeLibrary);
        }, null, this);
    },
    //初始化图书馆菜单显示
    initLibaranNav(){
      if(this.supperCentrallibrary.length>0){
        this.activeID  =1;
        this.activeLibrary = this.supperCentrallibrary;
      }else if(this.centralLibrary.length>0){
        this.activeID  =2;
        this.activeLibrary = this.centralLibrary;
      }else if(this.branchLibrary.length>0){
        this.activeID  =3;
        this.activeLibrary = this.branchLibrary;
      }else if(this.branchCentralLibrary.length>0){
        this.activeID  =4;
        this.activeLibrary = this.branchCentralLibrary;
      }else if(this.levelbranchLibrary.length>0){
        this.activeID  =5;
        this.activeLibrary = this.levelbranchLibrary;
      }else if(this.branchLibraryOutlets.length>0){
        this.activeID  =6;
        this.activeLibrary = this.branchLibraryOutlets;
      }
    },
    changeNav(params,arr){//切换菜单
      this.pageData={
        pageNo:1,//当前页码
        data:[],//当前页展示数据，数组
        pageSize:9,//每页最多显示条数
        length:0,//总的数据条数
        totalPage:1,//总页数
      };
      this.activeID = params;
      this.activeLibrary = arr;
      this.pageData = CommonUtil.getTableData(1,this.pageData.pageSize,this.activeLibrary)
    },
    //翻页操作
    pageChange(pageNo) {
      this.pageData = CommonUtil.getTableData(pageNo,this.pageData.pageSize,this.activeLibrary);
    },
    toLibraryInfo(agr) {
      //agr:libId, libCode, libName, libLevel, logo,websiteUrl
      if(agr[5]!=null && agr[5].trim()!=""){
        window.open(agr[5]);
        return;
      }
      var latLng = this.$route.query.latLng || store.localtionArea.latLng;
      var locationCode = this.$route.query.code || "510107";
      store.library.id = agr[0];
      store.library.libraryLevel = agr[3];
      store.library.name = agr[2];
      if(store.webType == 1) {
        CommonUtil.mergeQuery(this, {hallCode: agr[1]});
      }
      var url=store.webType==1 ? '/webintroduce':'/introduce';
      this.$router.push({
        path: url, query: {
          fromSearch: this.$route.query.fromSearch,
          libCode: agr[1],
          libId: agr[0],
          libName: agr[2],
          libLevel: agr[3],
          latLng: latLng,
          locationCode: locationCode,
        }
      });
    },
  },
}
